import { getColor, styled } from "imaginarity-react-ui";


export class GeneralPostSearchSC {
    public static TSAuto = styled.div<{ suggested: number }>`
        height: ${p => p.suggested ? p.suggested * 40 + "px" : "40px"};
        //background: ${p => p.theme.colors.mainBackground};
        float: left;
        color: ${p => p.theme.colors.mainForeground};
        width:100%;
        position: relative;
        margin-bottom: 2px;
        transition: all 0.2s ease-out;
        input{
            height: 40px;
            outline: none;
            width: 100%;
            padding: 0 10px;
            padding-left: 30px;
            transition: all 0.2s ease-out;
            border: 1px solid transparent;
            border-bottom: 1px solid rgba(0,0,0,0.1);
            background: rgba(0,0,0,0.03);
            background-color: rgba(0,0,0,0.03);
            color: rgba(0,0,0,0.3);;
        }
        input::placeholder {
            color: rgba(0,0,0,0.3);
            text-transform: uppercase;
            font-size: 0.7rem;
            line-height: 38px;
        }
        input:focus{
            background: rgba(0,0,0,0.06);
            background-color: rgba(0,0,0,0.06);
            border: 1px solid rgba(0,0,0,0.1);
            border-bottom-color: rgba(0,0,0,0.5);
            color: rgba(0,0,0,1);
            z-index: 20;
        }
        .searchIcon{
            position: absolute;
            left: -3px;
            top: 1px;
            width: 38px;
            height: 38px;
            float: left;
            text-align: center;
            svg{
                    stroke: rgba(0,0,0,1);
                }
            
        }
    `;

    public static TSSearchDelete = styled.div`
        position: absolute;
        right: 2px;
        top: 1px;
        width: 38px;
        height: 38px;
        float: right;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s ease;
        svg{
                stroke: ${p => getColor(p, p.theme.colors.lightGrey)};
            }
        &:hover{
            svg{
                stroke: ${p => getColor(p, p.theme.colors.accent)};
            }
        }
    `;
}   